import {Box, Button} from '@viptech/react-components'
import {useSnackbar} from 'notistack'
import React, {useRef, useState} from 'react'
import Progressbar, {ProgressbarColors} from 'src/components/Progressbar'
import useUploadDataset from 'src/hooks/api/companies/useUploadDataset'
import AttachFileIcon from 'src/images/AttachFileIcon'

export default function UploadDatasetFilePage() {
  const {mutateAsync: uploadDatasetFile, isPending, progress, eta} = useUploadDataset()
  const {enqueueSnackbar} = useSnackbar()
  const hiddenFileInput = useRef<HTMLInputElement>(null)
  const [file, setFile] = useState<File | null>(null)

  const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    try {
      const inputFile = event.target.files?.[0]
      if (!inputFile) return
      setFile(inputFile)
      await uploadDatasetFile(inputFile)
      enqueueSnackbar('Arquivo enviado com sucesso!', {
        variant: 'success',
      })
    } catch (error) {
      console.log(error)
    }

    if (hiddenFileInput.current) hiddenFileInput.current.value = ''
    setFile(null)
  }

  const handleFormatETA = (eta: number): string => {
    if (eta <= 0) return '0 segundos'
    const hours = Math.floor(eta / 3600)
    const minutes = Math.floor((eta % 3600) / 60)
    const seconds = eta % 60
    let formattedETA = ''
    if (hours > 0) formattedETA += `${hours} horas`
    if (minutes > 0) {
      if (formattedETA) formattedETA += hours > 0 && seconds > 0 ? ', ' : ' e '
      formattedETA += `${minutes} minutos`
    }
    if (seconds > 0) {
      if (formattedETA) formattedETA += ' e '
      formattedETA += `${seconds} segundos`
    }
    return formattedETA.trim()
  }

  const formatFileSize = (size: number): string => {
    const units = ['B', 'KB', 'MB', 'GB', 'TB']
    let index = 0
    let formattedSize = size
    while (formattedSize >= 1024 && index < units.length - 1) {
      formattedSize /= 1024
      index++
    }
    return `${formattedSize.toFixed(2)} ${units[index] ?? ''}`
  }

  return (
    <Box display='flex' align='center' justifyContent='center' direction='column' flex={1} rowGap='32px' backgroundColor='white'>
      <Box width='450px' display='flex' direction='column' height='400px' alignContent='center' rowGap='24px' align='center' justifyContent='center'>
        <Box display='flex' direction='column' rowGap='4px'>
          <Box display='flex' alignSelf='center' boxSizing='border-box' justifyContent='center' align='center'>
            <input type='file' multiple={false} accept='.tar,.gz,.xz,.zip,.rar' ref={hiddenFileInput} onChange={handleFileChange} style={{display: 'none'}} />
            <Button
              isLoading={isPending}
              disabledBgColor='#009EFF95'
              leftIcon={<AttachFileIcon />}
              padding='8px 16px 8px 16px'
              height='31px'
              width='220px'
              color='#009EFF'
              fontSize='12px'
              hoverColor='#1565c0'
              onClick={() => hiddenFileInput.current?.click()}>
              Fazer upload
            </Button>
          </Box>
          {file && (
            <p style={{fontSize: 12}}>
              Arquivo: {file.name}
              <br />
              Tamanho: {formatFileSize(file.size)}
            </p>
          )}
        </Box>

        {isPending && (
          <Box display='flex' direction='column' rowGap='4px' width='100%'>
            <p style={{textAlign: 'center', marginBottom: 12, fontSize: 14}}>Fazendo upload do arquivo... Isso pode levar alguns instantes</p>
            <Box display='flex' direction='row' width='100%'>
              {<Progressbar color={ProgressbarColors.GREEN} percentage={Math.round(progress)} fontSize='14px' height='8px' />}
            </Box>
            {eta !== null && eta > 0 && <p style={{fontSize: 12}}>Tempo estimado: {handleFormatETA(eta)}</p>}
          </Box>
        )}
      </Box>
    </Box>
  )
}
